import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import ExportService from "./ExportService";
import Header from "layouts/profile/components/Header";

function FiltroExportacao({ onAlert }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [type, setType] = useState("pedido");

  const handleExport = async () => {
    if (!startDate || !endDate) {
      onAlert("error", "Informe o intervalo de datas.");
      return;
    }

    try {
      await ExportService.exportar({ startDate, endDate, type });
      onAlert("success", `Exportando ${type}s de ${startDate} até ${endDate}`);
    } catch (error) {
      onAlert("error", "Erro ao exportar dados.");
    }
  };

  return (
    <Header customTitle={"Exportar oferta/pedido"} >
      <MDBox p={3}>
        <TextField
          label="Data Inicial"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ mr: 2 }}
        />
        <TextField
          label="Data Final"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ mr: 2 }}
        />
        <TextField
          label="Tipo"
          select
          SelectProps={{ native: true }}
          value={type}
          onChange={(e) => setType(e.target.value)}
          sx={{ mr: 2, minWidth: 150 }}
        >
          <option value="pedido">Pedido</option>
          <option value="oferta">Oferta</option>
        </TextField>
        <Button 
          variant="contained"
          sx={{
            background: "linear-gradient(90deg, #1976D2 0%, #42A5F5 100%)",
            color: "#fff",
            fontWeight: "bold",
            textTransform: "uppercase",
            borderRadius: "12px",
            padding: "8px 20px",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
            "&:hover": {
              background: "linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)",
            },
          }} 
          onClick={handleExport}
        >
          Exportar
        </Button>
      </MDBox>
    </Header>
  );
}

export default FiltroExportacao;
